module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-plus-fda23139fcfdd60d4c6765767f1e4ca1.svg";